import classFreedivingImg from "../images/imgs/class_freediving.jpg";
import classDefaultImg from "../images/imgs/class_default_img.jpg";
import mermaid_img from "../images/imgs/mermaid_img.webp";



// 다양한 스포츠와 관련된 정보를 배열로 정의합니다.
export const sportCategories = [
    {
        src: `${process.env.PUBLIC_URL}/images/icon_sport/freediving.svg`, // 스포츠와 관련된 아이콘 이미지 경로입니다.
        title: "프리다이빙", // 스포츠의 이름입니다.
        description: `프리다이빙은 장비 없이 자유롭게 물속을 탐험하는 스포츠입니다.\n 호흡 훈련과 함께 깊은 바다에서의 특별한 경험을 제공합니다.`, // 스포츠에 대한 설명입니다.
        img: classFreedivingImg,
    },
    {
        src: `${process.env.PUBLIC_URL}/images/icon_sport/scuba-diving.svg`,
        title: "스쿠버다이빙",
        description: `스쿠버는 수중 호흡 장비를 활용하여 바다 속 세상을 탐험하는 스포츠입니다.\n다양한 해양 생물과 아름다운 수중 경관을 만날 수 있습니다.`,
        img: classDefaultImg,
    },
    {
        src: `${process.env.PUBLIC_URL}/images/icon_sport/mermaid.svg`,
        title: "머메이드",
        description: `머메이드는 인어의 움직임을 모방한 수중 스포츠입니다.\n 특별한 핀을 착용하고 우아한 수중 동작을 배우며 독특한 경험을 제공합니다.`,
        img: mermaid_img,
    },
    {
        src: `${process.env.PUBLIC_URL}/images/icon_sport/Pilates.svg`,
        title: "필라테스",
        description: `필라테스는 몸의 코어 근력을 강화하고 유연성을 향상시키는 운동입니다.\n 정확한 동작과 호흡을 통해 균형 잡힌 신체를 만들 수 있습니다.`,
        img: classDefaultImg,
    },
    {
        src: `${process.env.PUBLIC_URL}/images/icon_sport/ice-hockey.svg`,
        title: "아이스하키",
        description:
            "아이스하키는 빙판 위에서 펼쳐지는 역동적인 팀 스포츠입니다.\n 빠른 스케이팅과 정확한 퍽 컨트롤을 통해 짜릿한 경기를 즐길 수 있습니다.",
        img: classDefaultImg,
    },
    {
        src: `${process.env.PUBLIC_URL}/images/icon_sport/snowboard.svg`,
        title: "스노우보드",
        description:
            "스노우보드는 눈 덮인 슬로프를 자유롭게 질주하는 겨울 스포츠입니다.\n 다양한 기술과 점프를 통해 스릴 넘치는 경험을 제공합니다.",
        img: classDefaultImg,
    },
    {
        src: `${process.env.PUBLIC_URL}/images/icon_sport/running.svg`,
        title: "러닝",
        description:
            "러닝은 가장 기본적이면서도 효과적인 유산소 운동입니다.\n 실외에서 자유롭게 달리며 체력을 향상시키고 스트레스를 해소할 수 있습니다.",
        img: classDefaultImg,
    },
    {
        src: `${process.env.PUBLIC_URL}/images/icon_sport/camping.svg`,
        title: "캠핑",
        description:
            "캠핑은 자연 속에서 휴식과 모험을 동시에 즐길 수 있는 아웃도어 활동입니다\n 가족, 친구들과 함께 특별한 추억을 만들 수 있습니다.",
        img: classDefaultImg,
    },
];

